import { Attachment } from './attachment.model';
export class Item {
    id?: number;
    title?: string;
    content?: string;
    resource_url?: string;
    resource_mimetype?: string;
    ost_id?: number;
    geom?: any;
    status?: string;
    active?: boolean;
    fk_experience?: number;
    scheda_url?: string;
    creation_date?: any;
    modification_date?: any;
    attachtments?: Attachment[];
    sysdefined?: boolean;
    stop?: string;
    locale?: string;
    description?: string;
    ost_descrizione?: string;
    ost_titolo?: string;
    ost_visitabile?: string;
    ost_lunghezza?: number;
    ost_changed?: any;
    ost_percorrenza?: number;

    constructor() {
        this.attachtments = [];
    }
}
